const action = {
    // Translate into vi
    sign_in: 'Đăng nhập',
    continue: 'Tiếp tục',
    create_account: 'Tạo tài khoản',
    create_account_without_linking: 'Tạo tài khoản mới',
    create: 'Tạo',
    enter_passcode: 'Nhập mã xác thực',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    save_password: 'Lưu mật khẩu',
    bind: 'Liên kết với {{address}}',
    bind_and_continue: 'Liên kết và tiếp tục',
    back: 'Quay lại',
    nav_back: 'Quay lại',
    nav_skip: 'Bỏ qua',
    agree: 'Đồng ý',
    got_it: 'Đã hiểu',
    sign_in_with: 'Tiếp tục với {{name}}',
    forgot_password: 'Quên mật khẩu?',
    switch_to: 'Chuyển sang {{method}}',
    sign_in_via_passcode: 'Đăng nhập bằng mã xác thực',
    sign_in_via_password: 'Đăng nhập bằng mật khẩu',
    change: 'Thay đổi {{method}}',
    link_another_email: 'Liên kết email khác',
    link_another_phone: 'Liên kết số điện thoại khác',
    link_another_email_or_phone: 'Liên kết email hoặc số điện thoại khác',
    show_password: 'Hiện mật khẩu',
    copy: 'Sao chép',
    verify_via_passkey: 'Xác thực bằng passkey',
    download: 'Tải xuống',
    single_sign_on: 'Đăng nhập một lần',
    authorize: 'Ủy quyền',
    use_another_account: 'Sử dụng tài khoản khác',
};
export default Object.freeze(action);
